import React from 'react';
import MarkdownPreview from '@uiw/react-markdown-preview';
import { MessageItemProps } from '../../interfaces/components/messageItem';


const MessageItem: React.FC<MessageItemProps> = ({
  message,
  currentStreamingMessageId,
  streamingContent,
}) => {
  return (
    <div
      key={message.id}
      className={`mb-4 ${
        message.isUser 
          ? 'ml-auto md:max-w-[30%] max-w-[80%]' 
          : 'mr-auto md:max-w-[80%] max-w-full'
      }`}
    >
      <div
        className={`p-3 rounded-lg ${
          message.isUser
            ? 'bg-primary text-white'
            : 'bg-white dark:bg-[#313131] text-gray-800 dark:text-gray-300'
        }`}
      >
        {message.isUser ? (
          <p className="text-sm">{message.content}</p>
        ) : (
          <div className="text-sm">
            <MarkdownPreview
              source={currentStreamingMessageId === message.id && message.isStreaming
                ? streamingContent || message.content
                : message.content}
              className="markdown-body"
              style={{ 
                backgroundColor: 'transparent',
                fontSize: '12px',
                color: 'inherit'
              }}
              data-color-mode="auto"
            />
          </div>
        )}
        <span className="text-xs opacity-70">
          {message.timestamp.toLocaleTimeString()}
        </span>
        {message.isStreaming && (
          <div className="mt-2 flex space-x-1">
            <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" />
            <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce delay-100" />
            <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce delay-200" />
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageItem; 